<template>
  <section class="bgFotoPaletten">
    <div class="row justify-content-center m-md-2">
      <div class="col-lg-8 text-center headline">
        <h1 class="headline">Paletten und Holzkisten</h1>
      </div>
    </div>
    <div class="row justify-content-center p-2 m-md-2">
      <div class="col-lg-6 DES bildschirnansicht text-center">
        <h2 class="headline2 p-4 m-5">
          Wir stehen für Qualität, Präzision und individuelle Lösungen.
        </h2>
      </div>
    </div>

    <div class="row justify-content-center p-2 m-md-2">
      <div class="col-lg-6 DES bildschirnansicht text-center">
        <h3 class="headline2 p-4 m-md-5">
          Euro-Paletten <br />
          <br />
          Einwegpaletten nach Wunschmaß<br /><br />
          Transportkisten aus Holz
        </h3>
      </div>
    </div>
  </section>
  <section>
    <div>
      <div class="row justify-content-center m-0 hellgrauHintergrund">
        <div class="col-lg-8 text-center">
          <h2 class="headline2 mt-5">Flexibel, effizient und passgenau:</h2>
          <h5 class="headline3">
            Paletten und Holzkisten – die stabile Basis für sicheren Transport.  <br/>Für
            schwere Lasten, lange Wege und höchste Ansprüche.  <br/>Vertrauen Sie auf
            zuverlässige Ladungsträger aus Holz.
          </h5>
        </div>
      </div>
    </div>
  </section>

  <section>
    <balkenMitBild />
  </section>
  <stickybarTelMail />
  <stickyPfeil />
</template>

<script>
import balkenMitBild from "../components/balkenMitBildPaletten.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";

export default {
  name: "ImpressumPage",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    balkenMitBild,
    stickyPfeil,
    stickybarTelMail,
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
